export const PREFIX = 'PROFILE_BONDS';
